import { Box, Step, StepContent, StepLabel, Stepper, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import Stepper01 from "./Stepper01";
import Stepper02 from "./Stepper02";
import Stepper03 from "./Stepper03";

export default function FormIncluirPrescricao() {
    const { watch } = useFormContext();
    const activeStep = watch("stepper");



    // Steps
    const steps: Array<ISteps> = [
        {
            label: "Dados Principais",
            component: <Stepper01 />,
            info: <Typography variant="body2">Informações básicas da Prescrição.</Typography>,
        },
        {
            label: "Dosagem e Aplicação",
            component: <Stepper02 />,
            info: <Typography variant="body2">Informações de dosagem e aplicação.</Typography>,
        },
        {
            label: "Informações complementares",
            component: <Stepper03 />,
            info: <Typography variant="body2">Informações complementares.</Typography>,
        },
    ];

    return (
        <Box sx={{ px: 4 }}>
            <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                    <Step key={step.label}>
                        <StepLabel
                            sx={{ alignItems: "flex-start" }}
                            optional={
                                index < activeStep ? (
                                    <Box
                                        sx={{
                                            pl: 4,
                                            top: 8,
                                            left: -20,
                                            position: "relative",
                                            borderLeft: "1px solid #bdbdbd",
                                        }}
                                    >
                                        {step.info}
                                    </Box>
                                ) : null
                            }
                        >
                            <Typography
                                marginBottom={2}
                                color={activeStep === index ? "#000000" : "rgba(0, 0, 0, 0.6)"}
                                variant="subtitle1"
                            >
                                {step.label}
                            </Typography>
                        </StepLabel>
                        <StepContent>{step.component}</StepContent>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
}

interface ISteps {
    label: string;
    component: React.ReactNode;
    info: React.ReactNode;
}